import React from 'react';
import ContentListBase from './ContentListBase';
import EmployeeList from './EmployeeList';
import PartOrderForm from './PartOrderForm';
import SimpleChat from './SimpleChat';
import InfoDashboard from './InfoDashboard';
import BranchMap from './BranchMap';

// --- VerticalMenu component ---
function VerticalMenu({ label, items }) {
  const [open, setOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(null);
  return (
    <div style={{ position: 'relative', minWidth: 220 }}>
      <button
        style={{
          width: '100%',
          padding: '14px 18px',
          borderRadius: 10,
          background: '#2563eb',
          color: '#fff',
          fontWeight: 600,
          fontSize: 17,
          border: 'none',
          cursor: 'pointer',
          boxShadow: open ? '0 4px 24px rgba(37,99,235,0.13)' : '0 2px 8px rgba(37,99,235,0.08)',
          marginBottom: 6,
        }}
        onClick={() => setOpen((v) => !v)}
        onBlur={() => setTimeout(() => setOpen(false), 200)}
      >
        {label}
      </button>
      {open && (
        <div
          style={{
            position: 'absolute',
            top: '110%',
            left: 0,
            zIndex: 20,
            background: '#fff',
            color: '#222',
            borderRadius: 10,
            boxShadow: '0 8px 32px rgba(0,0,0,0.13)',
            minWidth: 220,
            padding: '8px 0',
          }}
        >
          {items.map((item, idx) => (
            <div key={item.label} style={{ position: 'relative' }}>
              <button
                style={{
                  width: '100%',
                  padding: '12px 18px',
                  background: 'none',
                  border: 'none',
                  textAlign: 'left',
                  fontSize: 16,
                  color: '#222',
                  cursor: 'pointer',
                  fontWeight: 500,
                  borderRadius: 8,
                  transition: 'background 0.15s',
                  ...(item.submenu ? { fontWeight: 700 } : {}),
                }}
                onClick={item.onClick}
                onMouseEnter={() => item.submenu && setSubmenuOpen(idx)}
                onMouseLeave={() => item.submenu && setSubmenuOpen(null)}
              >
                {item.label}
                {item.submenu && (
                  <span style={{ float: 'right', fontWeight: 400 }}>&#9654;</span>
                )}
              </button>
              {item.submenu && submenuOpen === idx && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: '100%',
                    minWidth: 200,
                    background: '#fff',
                    color: '#222',
                    borderRadius: 10,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.13)',
                    zIndex: 30,
                  }}
                  onMouseEnter={() => setSubmenuOpen(idx)}
                  onMouseLeave={() => setSubmenuOpen(null)}
                >
                  {item.submenu.map((sub, subIdx) => (
                    <button
                      key={sub.label}
                      style={{
                        width: '100%',
                        padding: '12px 18px',
                        background: 'none',
                        border: 'none',
                        textAlign: 'left',
                        fontSize: 15,
                        color: '#222',
                        cursor: 'pointer',
                        fontWeight: 400,
                        borderRadius: 8,
                        transition: 'background 0.15s',
                      }}
                      onClick={sub.onClick}
                    >
                      {sub.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}



const Home = () => {
  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: 16 }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: 24,
          marginBottom: 32,
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: 24,
          }}
        >
          <InfoDashboard />
          <EmployeeList />
          <BranchMap />
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: 24,
          }}
        >
          <PartOrderForm />
          <SimpleChat />
        </div>
      </div>
      <h2 style={{ marginBottom: 20, marginTop: 32 }}>Зарууд</h2>
      <ContentListBase />
      <style>{`
        @media (min-width: 900px) {
          .home-main-grid {
            display: grid !important;
            grid-template-columns: 2fr 1fr !important;
            gap: 32px !important;
          }
        }
        @media (max-width: 899px) {
          .home-main-grid {
            display: grid !important;
            grid-template-columns: 1fr !important;
            gap: 24px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Home;
